import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import JSONModel from "sap/ui/model/json/JSONModel";
import { MeasurementUnitSelectDto, ServiceDto } from "../../models/ServiceDto";
import { GetAvailableLanguages } from "../../utils/LanguageUtil";
import { TranslationDto } from "akademika/akamont/models/TranslationDto";

/**
 * @namespace akademika.akamont.pages.serviceAdd
 */

export default class ServiceAdd extends BaseController {
  route = Routes.SERVICE_ADD;
  parentRoute = Routes.SERVICE_LIST;

  public async onRouteMatched() {
    const nameTranslations: TranslationDto[] = [];

    for (let lang of GetAvailableLanguages()) {
      nameTranslations.push({ language: lang.code, value: "" });
    }

    const measurementUnitOptions = await this.get<MeasurementUnitSelectDto[]>(
      "api/Service/GetMeasurementUnitSelectOptions"
    );

    this.setModel(
      new JSONModel({
        nameTranslations: nameTranslations,
        measurementUnits: measurementUnitOptions,
      } as ServiceDto)
    );
  }

  public async addService() {
    const serviceData = this.getModelData<ServiceDto>();

    await this.post("api/Service/AddService", {
      body: serviceData,
    });

    this.navTo(Routes.SERVICE_LIST);
  }
}
